import { ConfluenceSoftwarePageProps } from "../../../../../pages/software/confluence/anchors/confluence-software-page";

import { ConfluenceSoftwarePage } from "./confluence-software-page";

export const ConfluenceSoftwarePageTemplate = (
    props: ConfluenceSoftwarePageProps
) => {
    const ConfluenceSoftwarePageComponent = ConfluenceSoftwarePage;

    return <ConfluenceSoftwarePageComponent {...props} />;
};
